import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Watermark} from "@hirohe/react-watermark";

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <BrowserRouter basename="/">
      <Watermark text={process.env.REACT_APP_ENV} gutter="30" show={process.env.REACT_APP_ENV==="prod"?false:true}>
        <App/>
      </Watermark>
  </BrowserRouter>
);

reportWebVitals();
